export const handleChangeDataHeaderDesktop = (name, value) => ({
    type: 'CHANGE_DATA_HEADER_DESKTOP', name, value
});

export const ChangePrevSearchHistory = (limitedHistory) => ({
    type: 'CHANGE_PREV_SEARCH_HISTORY', limitedHistory
});

export const RemovePrevSearchHistory = () => ({
    type: 'REMOVE_PREV_SEARCH_HISTORY'
});